import { render, staticRenderFns } from "./Adverts.vue?vue&type=template&id=269b895d&"
import script from "./Adverts.vue?vue&type=script&lang=js&"
export * from "./Adverts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports